var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSerifXIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00632 17.9768L7.25684 17.6611L10.8821 13.0505L7.06737 8.26316L6.00632 8.01053C5.98105 7.68211 6.03158 7.35789 6.15789 7.03789H10.9958L11.0463 8.03579L9.65684 8.33895L12.1832 11.7747L14.6716 8.31368L12.9663 8.01053C12.9495 7.83368 12.9495 7.65684 12.9663 7.48C12.9832 7.30316 13.0211 7.14316 13.08 7H17.6147L17.7158 7.98526L16.4905 8.31368L13.0421 12.6716L17.2358 17.8L18.3726 17.9768C18.3979 18.1453 18.3979 18.3263 18.3726 18.52C18.3474 18.7053 18.3011 18.8653 18.2337 19H13.5347L13.4463 18.0147L14.6968 17.8632L11.7411 14.0484L9.02526 17.6863L10.8442 17.9768C10.8442 18.1453 10.8316 18.3221 10.8063 18.5074C10.7895 18.6926 10.76 18.8568 10.7179 19H6.15789L6.00632 17.9768Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerifXIcon);
export default __webpack_public_path__ + "static/media/serif-x-icon.615942867374cf1a01f3a680837260de.svg";
export { ForwardRef as ReactComponent };